module.exports = __webpack_public_path__ + "static/media/answer.b52d0968.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/answer.png
// module id = 121
// module chunks = 1